var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOcDashed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 359,
    height: 361,
    viewBox: "0 0 359 361",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8583 155.84C15.6256 123.968 29.3541 94.1069 50.4436 69.7387C71.533 45.3706 99.1145 27.4989 129.973 18.2071C160.831 8.91535 193.695 8.5862 224.733 17.2581C255.771 25.93 283.705 43.2456 305.278 67.1864C326.852 91.1273 341.176 120.707 346.58 152.477C351.985 184.248 348.248 216.9 335.804 246.628C323.361 276.355 302.724 301.934 276.299 320.381C249.875 338.828 218.751 349.385 186.556 350.819",
    stroke: "white",
    strokeWidth: 20,
    strokeDasharray: "1.5 5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOcDashed);
export default __webpack_public_path__ + "static/media/oc_dashed.aa1d7626e3cce5575197adfcd9a68da0.svg";
export { ForwardRef as ReactComponent };